import { defineComponent as r, computed as d, createBlock as i, openBlock as c, unref as o, normalizeClass as u, withCtx as m, createElementVNode as a, renderSlot as f, createVNode as p } from "vue";
import { RevButtonBase as h } from "@ds/components/ButtonBase";
import b from "../../../icons/generated/IconChevronDown.vue2.js";
import { tw as t } from "../../../utils/tailwind.js";
const _ = { class: "body-2-bold h-full text-start" }, v = { class: "pointer-events-none absolute inset-y-0 right-8 flex select-none items-center" }, y = /* @__PURE__ */ r({
  name: "InputSmallSelectButton",
  __name: "InputSmallSelectButton",
  props: {
    hasError: { type: Boolean },
    focused: { type: Boolean },
    disabled: { type: Boolean }
  },
  setup(n) {
    const e = n, s = d(() => [
      t`rounded-sm relative inline-block h-32 w-full transition-colors`,
      e.focused && !e.hasError && t`outline-default-low`,
      e.focused && e.hasError && t`outline-danger-low`,
      e.disabled ? t`bg-action-default-mid-disabled text-onaction-default-mid-disabled pointer-events-none` : t`bg-action-default-mid hover:bg-action-default-mid-hover`,
      !e.disabled && e.hasError && t`text-onaction-danger-mid`,
      !e.disabled && !e.hasError && t`text-onaction-default-mid`
    ]);
    return (l, B) => (c(), i(o(h), {
      class: u(s.value)
    }, {
      default: m(() => [
        a("div", _, [
          f(l.$slots, "value")
        ]),
        a("div", v, [
          p(o(b), { size: "20" })
        ])
      ]),
      _: 3
    }, 8, ["class"]));
  }
});
export {
  y as default
};
